import React from 'react';

const BitIcon = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M4.01938 11V9.57H0.509375V8.79L3.85938 4H5.00938V8.7H6.00938V9.57H5.00938V11H4.01938ZM1.59938 8.7H4.07938V5.1L1.59938 8.7ZM6.59031 12.01L9.09031 3.31H10.0703L7.57031 12.01H6.59031ZM13.5897 11V9.57H10.0797V8.79L13.4297 4H14.5797V8.7H15.5797V9.57H14.5797V11H13.5897ZM11.1697 8.7H13.6497V5.1L11.1697 8.7Z" fill="currentColor"/>
		</svg>
	);
};

export default BitIcon;
